import React from "react";
import { DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { AccessRequestOutcome } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { getAccessRequestOutcomeSelectOptions } from "../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";
import { showsWhenAccessIsRestricted } from "./incidentLogAccessRequestOutcomeVisibility.ts";

export interface IncidentLogAccessRequestOutcomeFieldProps {
    outcome?: AccessRequestOutcome | null;
    justification?: string;
    onOutcomeChange: (outcome: AccessRequestOutcome | null) => void;
    onJustificationChange: (justification: string) => void;
    isPreview: boolean;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogAccessRequestOutcomeField(props: IncidentLogAccessRequestOutcomeFieldProps) {
    const { translateString } = useTranslation();

    return (
        <>
            <DotLegalSelect
                options={getAccessRequestOutcomeSelectOptions(translateString)}
                selectedItem={props.outcome ? props.outcome.toString() : null}
                onChange={(outcome) => props.onOutcomeChange(outcome ? (Number(outcome) as AccessRequestOutcome) : null)}
                label={translateString("accessRequestOutcome")}
                noOptionsLabel={translateString("noOptions")}
                disabled={props.disabled}
                errorText={props.errorText}
            />
            {showsWhenAccessIsRestricted(props.outcome, props.isPreview) && (
                <DotLegalTextField
                    label={translateString("accessRequestOutcomeJustification")}
                    value={props.justification ?? ""}
                    debounce
                    multiline
                    rows={3}
                    onChange={props.onJustificationChange}
                    disabled={props.disabled}
                />
            )}
        </>
    );
}

export default IncidentLogAccessRequestOutcomeField;
